import { render, staticRenderFns } from "./lk-table.vue?vue&type=template&id=2b1ef392&"
import script from "./lk-table.vue?vue&type=script&lang=js&"
export * from "./lk-table.vue?vue&type=script&lang=js&"
import style0 from "./lk-table.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-table/lk-table.vue
// module id = 1467
// module chunks = 0